
import {gsap} from "../LibrariesImport";
export default class Stickers {
	constructor() {

		this.card = document.querySelector(".sticker");

		if( !this.card ){
			return;
		}

		this.cities = this.card.querySelector('[data-cities]');

		this.citiesArray = this.cities.dataset.cities.split(",");

		if( this.citiesArray.length === 1 || this.citiesArray.length === 0 ){
			return;
		}

		const tl = gsap.timeline({ repeat: -1 }); // -1 pour boucler à l'infini

		this.citiesArray.forEach((ville, index) => {
			tl.to(this.cities, {
				duration: 1.5,
				onStart: () => {
					this.cities.innerHTML = ville;
				}
			}).to({}, { duration: 2 });
			if (index === this.citiesArray.length - 1) {
				tl.to(this.cities, {
					duration: 1.5,
					onStart: () => {
						this.cities.innerHTML = this.citiesArray[0];
					}
				});
			}
		});

		let priceElement = this.card.querySelector('[data-average]');
		const prices = priceElement.dataset.average.split(",").map(p => parseFloat(p.replace(/\s/g, '')));

		// On s'assure que la valeur de départ est bien le premier prix
		let currentValue = { val: prices[0] };

		const tlAverage = gsap.timeline({ repeat: -1 });

		prices.forEach((targetPrice, index) => {
			// 1. Animation vers le prix cible
			tlAverage.to(currentValue, {
				val: targetPrice,
				duration: 1.5,
				ease: "power2.inOut",
				onUpdate: () => {
					priceElement.querySelector('.number').textContent = Math.round(currentValue.val)
						.toLocaleString('fr-FR')
						.replace(/\u00a0/g, ' ');
				}
			})
				// 2. Pause sur le prix affiché
				.to({}, { duration: 2 });

			// 3. SI c'est le dernier prix du tableau, on ajoute une transition
			// supplémentaire pour revenir au premier prix en douceur
			if (index === prices.length - 1) {
				tlAverage.to(currentValue, {
					val: prices[0],
					duration: 1.5,
					ease: "power2.inOut",
					onUpdate: () => {
						priceElement.querySelector('.number').textContent = Math.round(currentValue.val)
							.toLocaleString('fr-FR')
							.replace(/\u00a0/g, ' ');
					}
				});
			}
		});

		let priceElementPrimmea = this.card.querySelector('[data-average-primmea]');
		const pricesPrimmea = priceElementPrimmea.dataset.averagePrimmea.split(",").map(p => parseFloat(p.replace(/\s/g, '')));

		// Initialisation à la première valeur du tableau pour éviter un saut au démarrage
		let currentValuePrimmea = { val: pricesPrimmea[0] };

		const tlAveragePrimmea = gsap.timeline({ repeat: -1 });

		pricesPrimmea.forEach((targetPrice, index) => {
			// 1. Animation vers le prix actuel de l'itération
			tlAveragePrimmea.to(currentValuePrimmea, {
				val: targetPrice,
				duration: 1.5,
				ease: "power2.inOut",
				onUpdate: () => {
					priceElementPrimmea.querySelector('.number').textContent = Math.round(currentValuePrimmea.val)
						.toLocaleString('fr-FR')
						.replace(/\u00a0/g, ' ');
				}
			})
				// 2. Temps d'arrêt (pause) sur le chiffre
				.to({}, { duration: 2 });

			// 3. Boucle de retour : si c'est le dernier prix, on anime le retour vers le premier
			if (index === pricesPrimmea.length - 1) {
				tlAveragePrimmea.to(currentValuePrimmea, {
					val: pricesPrimmea[0],
					duration: 1.5,
					ease: "power2.inOut",
					onUpdate: () => {
						priceElementPrimmea.querySelector('.number').textContent = Math.round(currentValuePrimmea.val)
							.toLocaleString('fr-FR')
							.replace(/\u00a0/g, ' ');
					}
				});
			}
		});

	}

}
